import { AriaPopup } from 'js-component-framework/lib/plugins';

/**
 * Accordion version of AriaPopUp.
 */
export default class AriaAccordion extends AriaPopup {
  /**
   * Constructor.
   * @param config
   */
  // eslint-disable-next-line no-useless-constructor
  constructor(config) {
    super(config);
  }

  /**
   * Override the outsideClick method in AriaPopUp.
   * We don't want this functionality when using Accordions. See ACM-1194
   */
  // eslint-disable-next-line class-methods-use-this
  outsideClick() {}
}
